'use client';
import React from 'react';
import { Product } from 'shared/types/product/Product';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import ProductDetail from '../../../../../components/customercenter-ui/components/product/details';

const ProductDetailTastic = ({ data }: TasticProps<DataSource<{ product: Product }>>) => {
  if (!data?.data?.dataSource?.product) return null;
  return <ProductDetail widgetData={data} product={data?.data?.dataSource.product} colorsForBadges={undefined} />;
};

export default ProductDetailTastic;
